<template>
  <div class="skeleton">
    <section class="presentation">
      <div class="fill mb-5 w-75"></div>
      <div class="row">
        <div class="col-md-12 col-lg-6">
          <div class="img-wrapper">
            <div class="fill main-img" />
          </div>
          <div class="media-gallery my-4">
            <div v-for="n of 4" :key="n" class="d-flex img-wrapper">
              <div class="fill gallery-img" />
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-6" :style="`min-height: ${mainImgHeight}px`">
          <div class="fill mb-5 w-50"></div>
          <div class="h1 fill mb-4 w-75"></div>
          <div class="fill mb-4 w-25"></div>
          <div class="fill mb-4 w-25"></div>

          <div class="fill mb-4 w-100" style="height: 150px"></div>
          <div class="fill mb-4 w-75" style="height: 100px"></div>

          <div class="mb-4 p-3 w-75 usps">
            <div class="fill mb-3 w-75"></div>
            <div class="fill mb-3 w-75"></div>
            <div class="fill w-75"></div>
          </div>

          <div class="fill mb-3 w-50"></div>
          <div class="fill mb-4 w-33"></div>
          <div class="fill mb-4 w-75"></div>
        </div>
      </div>
    </section>

    <hr />

    <section class="info">
      <div class="other-properties">
        <div class="h2 fill mb-4 w-50"></div>
        <div v-for="g of 3" :key="g" class="pb-4">
          <div v-for="p of 5" :key="p" class="fill mb-2" :class="[p % 3 === 2 ? 'w-50' : p % 3 === 1 ? 'w-33' : 'w-25']"></div>
        </div>
        <div class="pb-3">
          <div v-for="p of 2" :key="p" class="fill mb-3" :class="[p % 2 ? 'w-75' : 'w-50']"></div>
        </div>

        <div v-for="g of 3" :key="g" class="pb-4">
          <div v-for="p of 4" :key="p" class="fill mb-2" :class="[p % 3 === 2 ? 'w-50' : p % 3 === 1 ? 'w-33' : 'w-25']"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
defineProps<{ mainImgHeight: number }>()
</script>

<style lang="scss" scoped>
@use '@/styles/skeleton.scss';
</style>
